export default "__VITE_ASSET__B5dbm$x4__"